<template>
  <base-layout>
    <template v-slot:header>
      <router-view></router-view>
      <h1 class="text-3xl font-bold leading-tight text-gray-900">
        Edukacija
      </h1>
    </template>
    <template v-slot:default>
      <div class="space-y-8 divide-y divide-gray-200 sm:space-y-5 mb-5">
        <div>
          <div>
            <h3 class="text-lg leading-6 font-medium text-gray-900">
              Test: {{ quiz.quiz }}
            </h3>
          </div>
        </div>
      </div>
      <div class="space-y-8 sm:space-y-5 mb-5 h-auto">
        <div
          class="divide-y divide-gray-200 pt-8 space-y-6 sm:pt-10 sm:space-y-5"
        >
          <div>
            <h3 class="text-lg leading-6 font-medium text-gray-900">
              {{ quiz.message }}
            </h3>
          </div>
        </div>
      </div>
      <div class="pt-5">
        <div class="flex justify-start">
          <router-link
            type="button"
            to="/education/my-tests/"
            class="bg-white py-2 px-4 border border-gray-300 rounded-md shadow-sm text-sm font-medium text-gray-700 hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 cursor-pointer"
          >
            Nazad na moje testove
          </router-link>
        </div>
      </div>
    </template>
  </base-layout>
</template>

<script>
import EducationMyTest from "./EducationMyTest";
export default EducationMyTest;
</script>
